module.exports = __webpack_public_path__ + "media/luxury-2026/coastal-water-kitchen-fe9c54e0.jpg";